import React from "react"
import { connect } from "react-redux"
import { compose, withPropsOnChange } from "recompact"
import Fieldset from "@infotech/uikit-fieldset"
import { Field, getFormValues, change } from "redux-form"
import * as entity from "src/engine/modules/entity"
import resourceTypeCustomFieldsModel from "src/models/resourceType/models/customField"
import collection from "src/hocs/collection"
import Input from "src/components/Input"

const MAP_FIELD_TYPE_TO_COMPONENT = {
  string: Input,
}

const fieldTypeToComponent = type =>
  MAP_FIELD_TYPE_TO_COMPONENT[type] || `input`

export default formName => {
  const formValuesSelector = getFormValues(formName)

  return compose(
    connect(
      state => ({
        formValues: formValuesSelector(state),
      }),
      dispatch => ({
        eraseFields: () => dispatch(change(formName, `fields`, {})),
      }),
    ),
    withPropsOnChange(
      (props, nextProps) => {
        if (
          Object(nextProps.formValues).resourceTypeId !==
          Object(props.formValues).resourceTypeId
        ) {
          if (Object(props.formValues).resourceTypeId) {
            props.eraseFields()
          }
          return true
        }

        return false
      },
      props => {
        if (props.formValues && props.formValues.resourceTypeId) {
          const typeCustomFieldsEnhancer = compose(
            collection({
              engine: entity,
              to: `resourceTypesFields`,
              model: resourceTypeCustomFieldsModel(
                props.formValues.resourceTypeId,
              ),
              query: {
                limit: -1,
              },
            }),
          )

          return {
            CustomFields: typeCustomFieldsEnhancer(
              ({ resourceTypesFields: { data }, isDisabled }) => (
                <div>
                  {data.map(field => (
                    <Fieldset caption={field.label}>
                      <Field
                        name={`fields.${field.name}`}
                        component={fieldTypeToComponent(field.type)}
                        props={{
                          disabled: isDisabled,
                        }}
                      />
                    </Fieldset>
                  ))}
                </div>
              ),
            ),
          }
        }
        return {
          CustomFields: () => null,
        }
      },
    ),
  )
}
